<script>
import {
  mesAchatsFiltersEmits,
  mesAchatsFiltersProps,
  useMesAchatsFilters
} from "./mixin";
import PopinAnchor from "@/components/molecules/popin-anchor";
import Icon from "@/components/atoms/icon";
import FormGroup from "@/components/molecules/form-group";
import FormCheckbox from "@/components/molecules/form-checkbox";
import FormRadio from "@/components/molecules/form-radio";
import FormInput from "@/components/molecules/form-input";
import Button from "@/components/atoms/button";
import Filtersearch from "@/components/molecules/filter-search";

export default {
  name: "MesAchatsFilters",
  components: {
    PopinAnchor,
    Icon,
    FormGroup,
    FormCheckbox,
    FormRadio,
    FormInput,
    Button,
    Filtersearch
  },
  props: {
    ...mesAchatsFiltersProps()
  },
  methods: {
    popinDateUpdate() {
      this.updateDate();
      this.$refs.popinPeriode.close();
    },
    updateMontantPopin() {
      this.updateMontant();
      this.$refs.popinMontant.close();
    },
    updateMagasinPopin() {
      this.updateMagasin();
      this.$refs.popinMagasin.close();
      this.searchWord = "";
    }
  },
  emits: [...mesAchatsFiltersEmits()],
  setup(props, context) {
    const {
      dateMinInput,
      dateMaxInput,
      montantMinInput,
      montantMaxInput,
      garantieInput,
      searchWord,
      libellePeriode,
      filtreMagasin,
      dateSelectorDisabled,
      montantSelectorDisabled,
      magasinsSearchResult,
      searchMagasin,
      updateDate,
      updateMontant,
      updateMagasin,
      updateGarantie,
      syncFiltres
    } = useMesAchatsFilters(props, context);

    onBeforeMount(syncFiltres);

    return {
      dateMinInput,
      dateMaxInput,
      montantMinInput,
      montantMaxInput,
      garantieInput,
      searchWord,
      libellePeriode,
      filtreMagasin,
      dateSelectorDisabled,
      montantSelectorDisabled,
      magasinsSearchResult,
      searchMagasin,
      updateDate,
      updateMontant,
      updateMagasin,
      updateGarantie
    };
  }
};
</script>

<template>
  <div class="u-flex u-flex-justify-between">
    <div class="u-flex u-flex-align-center">
      <PopinAnchor
        ref="popinPeriode"
        popin-size="md"
        radius="sm"
        show-close-button
        button-class="c-button--achat-filter"
        class="u-mr-sm"
        has-input
      >
        <template #button-content>
          Période d'achat
          <Icon
            name="arrow-down"
            size="xs"
            class="c-filter-achat__button-filter-icon"
          />
        </template>

        <div class="c-filter-achat__dropdown-content">
          <p class="u-font-500 u-mb-md">
            Filtrer par période d’achat
          </p>
          <div>
            <FormGroup class="u-mb-md">
              <FormRadio
                v-model="libellePeriode"
                class="u-mb-sm"
                value="thisMonth"
                @change="popinDateUpdate()"
              >
                Ce mois-ci
              </Formradio>
              <FormRadio
                v-model="libellePeriode"
                class="u-mb-sm"
                value="lastMonth"
                @change="popinDateUpdate()"
              >
                Le mois dernier
              </Formradio>
              <FormRadio
                v-model="libellePeriode"
                class="u-mb-sm"
                value="lastThreeMonth"
                @change="popinDateUpdate()"
              >
                Les 3 derniers mois
              </Formradio>
              <FormRadio
                v-model="libellePeriode"
                value="custom"
              >
                Période personnalisée
              </Formradio>
            </FormGroup>
          </div>
          <div class="c-filter-achat__inputs-wrapper">
            <div class="c-filter-achat__inputs">
              <div class="c-filter-achat__input">
                <FormInput
                  v-model.trim="dateMinInput"
                  size="sm"
                  title="Date de début"
                  type="date"
                  active
                  @input="libellePeriode = 'custom'"
                >
                  Du
                </FormInput>
              </div>

              <span class="c-filter-price__input-separator">-</span>
              <div class="c-filter-achat__input">
                <FormInput
                  v-model.trim="dateMaxInput"
                  size="sm"
                  title="Date de fin"
                  type="date"
                  active
                  @input="libellePeriode = 'custom'"
                >
                  Au
                </FormInput>
              </div>
            </div>
            <Button
              size="sm"
              radius="full"
              variant="primary"
              class="u-ml-sm"
              :disabled="dateSelectorDisabled"
              @click="popinDateUpdate()"
            >
              OK
            </Button>
          </div>
          <div class="u-flex u-flex-align-center u-mt-md">
            <Icon
              variant="primary-light"
              name="info-circle"
              size="sm"
              class="u-flex-self-start u-flex-shrink-none u-mr-xxs"
            />
            <p class="u-font-14 u-color-text-light">
              Vos tickets de caisse sont conservés pendant une durée de 2 ans
            </p>
          </div>
        </div>
      </PopinAnchor>

      <PopinAnchor
        ref="popinMontant"
        popin-size="md"
        radius="sm"
        show-close-button
        button-class="c-button--achat-filter"
        class="u-mr-sm"
        has-input
      >
        <template #button-content>
          Montant
          <Icon
            name="arrow-down"
            size="xs"
            class="c-filter-achat__button-filter-icon"
          />
        </template>
        <div class="c-filter-achat__dropdown-content">
          <p class="u-font-500 u-mb-md">
            Filtrer par montant
          </p>

          <div class="c-filter-achat__inputs-wrapper c-filter-achat__inputs-wrapper--montant">
            <div class="c-filter-achat__inputs">
              <div class="c-filter-achat__input">
                <FormInput
                  v-model="montantMinInput"
                  size="sm"
                  suffix="€"
                  type="number"
                  title="Filtre prix minimum"
                >
                  De
                </FormInput>
              </div>

              <span class="c-filter-price__input-separator">-</span>
              <div class="c-filter-achat__input">
                <FormInput
                  v-model="montantMaxInput"
                  size="sm"
                  suffix="€"
                  type="number"
                  title="Filtre prix maximum"
                >
                  À
                </FormInput>
              </div>
            </div>
            <Button
              size="sm"
              radius="full"
              variant="primary"
              class="u-ml-sm"
              :disabled="montantSelectorDisabled"
              @click="updateMontantPopin()"
            >
              OK
            </Button>
          </div>
        </div>
      </PopinAnchor>

      <PopinAnchor
        ref="popinMagasin"
        popin-size="md"
        radius="sm"
        show-close-button
        button-class="c-button--achat-filter"
        has-input
        @click="searchWord = ''"
      >
        <template #button-content>
          Magasin
          <Icon
            name="arrow-down"
            size="xs"
            class="c-filter-achat__button-filter-icon"
          />
        </template>

        <div class="c-filter-achat__dropdown-content">
          <p class="u-font-500 u-mb-md">
            Filtrer par magasin
          </p>
          <div>
            <Filtersearch
              placeholder="un magasin"
              class="u-mb-md"
              @input="searchMagasin"
            />
            <FormGroup class="c-filter-achat__shops u-mb-md">
              <FormRadio
                v-for="magasin in magasinsSearchResult"
                :key="magasin.id"
                v-model="filtreMagasin.mag_id"
                :value="magasin.id"
                class="u-mb-sm"
                @change="updateMagasinPopin()"
              >
                {{ magasin.attributes.cp.substring(0, 2) }} - {{ magasin.attributes.magasin }}
              </Formradio>
            </FormGroup>
          </div>
        </div>
      </PopinAnchor>

      <FormCheckbox
        v-model="garantieInput"
        class="u-ml-sm"
        @change="updateGarantie"
      >
        <span class="u-font-14">
          Ticket avec produit sous garantie
        </span>
      </FormCheckbox>
    </div>
    <PopinAnchor
      popin-size="sm"
      link
      icon-name="help-circle-outline"
      icon-color="primary"
      icon-color-hover="primary-light"
      icon-position="left"
      icon-size="sm"
      position="bottom-left"
      infobulle
      open-on-hover
      class="c-filter-achat__info u-mr-sm"
    >
      <p class="u-font-14">
        Réglez avec votre carte cora Cpay Mastercard ou présentez votre carte Malin lors de votre passage en caisse, pour retrouver vos tickets de caisse dans cette page.
      </p>
    </PopinAnchor>
  </div>
</template>

<style lang="scss" scoped>
.c-filter-achat__button-filter-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.8rem;
  flex-shrink: 0;
}
@import "@/assets/styles/components/filter-achat.scss";
</style>
